import {inject, Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {StorageService} from "../../services/storage/storage.service";
import {OrgDto} from "../dto/org.dto";
import {UrlBuilder} from "../item/url.item";
import {WrapperDto} from "../dto/wrapper.dto";
import {map} from "rxjs/operators";
import {CurrencyDto} from "../dto/currency.dto";
import {Observable} from "rxjs";

@Injectable({providedIn: 'root'})
export class CurrencyRepo {

  private readonly expireInSeconds = 60 * 60 * 12; // 12h
  private readonly allStorageKeyPrefix = 'currency:all:';
  private readonly allRead = '/v1/org/{orgId}/currency/all';
  private readonly currentStorageKeyPrefix = 'currency:current:';
  private readonly currentRead = '/v1/org/{orgId}/currency/current';

  private readonly http: HttpClient = inject(HttpClient);
  private readonly storageService: StorageService = inject(StorageService);

  public readAll(org: OrgDto): Observable<WrapperDto<CurrencyDto>> {
    const url = UrlBuilder.builder().addPath(this.allRead).addParam('orgId', org.id).build();
    return this.storageService.cache(this.allStorageKeyPrefix + org.id,
      () => this.http.get<WrapperDto<CurrencyDto>>(url.getUrl(), url.getOptions()),
      this.expireInSeconds
    ).pipe(map((res) => new WrapperDto(res)));
  }

  public readCurrent(org: OrgDto): Observable<WrapperDto<CurrencyDto>> {
    const url = UrlBuilder.builder().addPath(this.currentRead).addParam('orgId', org.id).build();
    return this.storageService.cache(this.currentStorageKeyPrefix + org.id, () =>
      this.http.get<WrapperDto<CurrencyDto>>(url.getUrl(), url.getOptions())
    ).pipe(map((res) => new WrapperDto(res)));
  }
}
